module.exports = __webpack_public_path__ + "img/linkedin.9d614f3f.svg";